var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",class:[
    _vm.$style.wrapper,
    _vm.$style[_vm.lowerCaseUser],
    ( _obj = {}, _obj[_vm.$style.firstChild] = _vm.isFirstChild, _obj ) ]},[_c('div',{class:_vm.$style.inner},[_vm._t("default"),(_vm.isBot)?_c('span',{class:_vm.$style.markdownBody,domProps:{"innerHTML":_vm._s(_vm.renderedHtml)}}):_c('span',{domProps:{"textContent":_vm._s(_vm.html)}}),(_vm.timestamp)?_c('sub',{class:_vm.$style.time},[_vm._v(_vm._s(_vm._f("niceTime")(_vm.timestamp)))]):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }